import { OtpChallenge } from '@/components/auth/OtpChallenge';
import {
  useResendOtpMutation,
  useVerifyEmailMutation,
} from '@/features/auth/useAuthMutations';
import { useAuth } from '@/providers/AuthProvider';
import type { WizardState } from '../wizardState';

interface Props {
  onComplete: (patch: Partial<WizardState>) => void;
}

export function EmailStep({ onComplete }: Props) {
  const { user } = useAuth();
  const verifyMutation = useVerifyEmailMutation();
  const resendMutation = useResendOtpMutation();

  if (!user) return null;

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h2 className="font-display text-2xl font-semibold">Confirmar e-mail</h2>
        <p className="mt-1 text-sm text-(--color-fg-muted)">
          Enviamos um código para o e-mail informado no cadastro.
        </p>
      </div>
      <OtpChallenge
        channel="email"
        destination={user.email}
        onVerify={async (code) => {
          await verifyMutation.mutateAsync(code);
          onComplete({});
        }}
        onResend={async () => {
          await resendMutation.mutateAsync('email');
        }}
      />
    </div>
  );
}
